import React, { useCallback, useEffect, useState } from 'react';
import { Badge, Button, Popover, List, Typography, Empty } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import api from '../utils/api';

const { Text } = Typography;
const POLL_MS = 60000;

const NotificationBell = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ unread: 0, results: [] });
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    if (document.hidden) return;
    api.get('/auth/notifications/').then((r) => setData(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, POLL_MS);
    return () => clearInterval(t);
  }, [load]);

  const markRead = (ids) => api.post('/auth/notifications/read/', ids ? { ids } : {}).then(load).catch(() => {});

  const go = (n) => {
    if (!n.read_at) markRead([n.id]);
    setOpen(false);
    if (n.link) navigate(n.link);
  };

  const content = (
    <div style={{ width: 'min(360px, calc(100vw - 48px))', maxHeight: 420, overflowY: 'auto' }}>
      {data.results.length ? (
        <List size="small" dataSource={data.results} renderItem={(n) => (
          <List.Item style={{ cursor: 'pointer', background: n.read_at ? undefined : '#e6f4ff' }} onClick={() => go(n)}>
            <List.Item.Meta
              title={<Text strong={!n.read_at}>{n.title}</Text>}
              description={<>{n.body && <div>{n.body}</div>}<Text type="secondary" style={{ fontSize: 12 }}>{dayjs(n.created_at).format('DD/MM/YYYY HH:mm')}</Text></>} />
          </List.Item>
        )} />
      ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No messages" />}
    </div>
  );

  return (
    <Popover trigger="click" placement="bottomRight" open={open} onOpenChange={(o) => { setOpen(o); if (o) load(); }} content={content}
      title={<span>Messages {data.unread > 0 && <Button size="small" type="link" onClick={() => markRead()}>Mark all read</Button>}</span>}>
      <Badge count={data.unread} size="small" offset={[-2, 2]}>
        <Button type="text" icon={<BellOutlined style={{ fontSize: 18 }} />} aria-label="Messages" />
      </Badge>
    </Popover>
  );
};

export default NotificationBell;
